import styles from './style.postcss';

import React from 'react';
import { moment, testClass } from 'omni-common-ui';
import is from 'is_js';
import classnames from 'classnames';
import CardActionIcons from 'components/CardActionIcons';
import UserCard from 'components/UserCard';
import PropTypes from 'prop-types';

const InternalNoteView = (props) => {
  const {
    showBottomLine,
    canOperate,
    note,
    onEditButtonClick,
    onDeleteButtonClick,
    hideActionButtons,
  } = props;

  const dateStr = is.existy(note.date) && is.existy(note.timeZone) ?
    moment.parseZone(note.date).clone().tz(note.timeZone).format('YYYY-MM-DD') : '';
  return <div className={styles.InternalNoteView}>
    <div className={styles.InternalNoteView_header}>
      {
        (hideActionButtons || ! canOperate) ? null :
        <CardActionIcons className={styles.InternalNoteView_header_actions}
            onEditClick={() => onEditButtonClick()}
            onDeleteClick={() => onDeleteButtonClick()} />
      }
      <div className={styles.InternalNoteView_header_info}>
        <UserCard id={note.userId} dateStr={dateStr} />
      </div>
    </div>
    <p className={classnames(styles.InternalNoteView_note, testClass('note-content'))}>{note.note}</p>
    {
      showBottomLine &&
      <div className={styles.InternalNoteView_noteWithBottomLine} />
    }
  </div>;
};

InternalNoteView.propTypes = {
  canOperate: PropTypes.bool,
  showBottomLine: PropTypes.bool,
  note: PropTypes.object.isRequired,
  onEditButtonClick: PropTypes.func,
  onDeleteButtonClick: PropTypes.func,
  hideActionButtons: PropTypes.bool,
};

export default InternalNoteView;



// WEBPACK FOOTER //
// ./components/InternalNoteView/index.jsx